// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "HeroSectionLinks-module--wrapper--+RcOl";
export var title = "HeroSectionLinks-module--title--CYtvp";
export var navItem = "HeroSectionLinks-module--navItem--XEZGo";
export var red = "HeroSectionLinks-module--red--sZgwQ";
export var blue = "HeroSectionLinks-module--blue--oqeSY";
export var yellow = "HeroSectionLinks-module--yellow--XLC2B";
export var violet = "HeroSectionLinks-module--violet--qyvp6";